import { useContext } from 'react';
import { ModeContext } from './modeContext';

export const useMode = () => {
    return useContext(ModeContext);
};
